import { atomWithStorage, createJSONStorage } from 'jotai/utils'

export const statsAssistantPanelOpenAtom = atomWithStorage<boolean>(
  'dictation-stats-panel-open',
  false,
  createJSONStorage(() => sessionStorage),
  {
    getOnInit: true,
  },
)
